import { Injectable } from '@angular/core';
import { Firestore, collection, query, orderBy, where, getDocs } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { addDoc, Timestamp } from 'firebase/firestore';
import { CourseApplication } from '../../models/courseApplication';

@Injectable({
  providedIn: 'root'
})
export class CourseApplicationService {
  private collectionName = 'courseApplication';

  constructor(private firestore: Firestore) {}

  // Create a course application
  createApplication(application: CourseApplication): Observable<any> {
    const applicationsRef = collection(this.firestore, this.collectionName);
    return from(addDoc(applicationsRef, {
      ...application,
      createdAt: Timestamp.now()
    }));
  }

  // Get all course applications, sorted by createdAt (descending)
  getAllApplications(sortBy: string = 'createdAt', sortDirection: 'asc' | 'desc' = 'desc'): Observable<CourseApplication[]> {
    const applicationsRef = collection(this.firestore, this.collectionName);
    const q = query(applicationsRef, orderBy(sortBy, sortDirection));
    return from(getDocs(q)).pipe(
      map(snapshot => snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as CourseApplication))
    ));
  }

  // Get course applications by level (e.g., 'A1-A2' or 'B1-B2')
  getApplicationsByLevel(level: string): Observable<CourseApplication[]> {
    const applicationsRef = collection(this.firestore, this.collectionName);
    const q = query(applicationsRef, where('level', '==', level));
    return from(getDocs(q)).pipe(
      map(snapshot => snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as CourseApplication))
      ));
  }

  // Get course applications by status (e.g., 'pending', 'accepted', 'rejected')
  getApplicationsByStatus(status: 'pending' | 'accepted' | 'rejected'): Observable<CourseApplication[]> {
    const applicationsRef = collection(this.firestore, this.collectionName);
    const q = query(applicationsRef, where('status', '==', status));
    return from(getDocs(q)).pipe(
      map(snapshot => snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as CourseApplication))
    ));
  }
}